import { useUser } from '@folklore/auth';
import classNames from 'classnames';
import { MouseEvent, ForwardedRef } from 'react';
import { FormattedMessage } from 'react-intl';

import { useAuthLogout } from '../../hooks/useAuth';

import BasicButton from '../buttons/BasicButton';
import AccountIcon from '../icons/AccountIcon';

import styles from '../../styles/fields/user-field.module.css';

export interface UserFieldProps {
    withBorder?: boolean;
    withoutLogout?: boolean;
    className?: string | null;
    inputClassName?: string | null;
    [key: string]: unknown;
}

function UserField({
    withBorder = false,
    withoutLogout = false,
    className = null,
    inputClassName = null,
    ref: inputRef = null,
    ...props
}: UserFieldProps & { ref?: ForwardedRef<HTMLDivElement> | null }) {
    const user = useUser();
    const { email, phone } = user || {};
    const { logout } = useAuthLogout();
    const onClickLogout = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        logout();
    };
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.withBorder]: withBorder,
                },
                className,
            ])}
            ref={inputRef}
            {...props}
        >
            <div className={classNames([styles.input, inputClassName])}>
                <AccountIcon circleColor="transparent" className={styles.icon} loggedIn />
                <span className={styles.label}>{email || phone}</span>
            </div>

            {user !== null && !withoutLogout ? (
                <div className={styles.logout}>
                    <FormattedMessage
                        defaultMessage="Ce n’est pas vous? {link}"
                        description="Logout label"
                        values={{
                            link: (
                                <BasicButton className={styles.link} onClick={onClickLogout}>
                                    <FormattedMessage
                                        defaultMessage="Déconnectez-vous"
                                        description="Button label"
                                    />
                                </BasicButton>
                            ),
                        }}
                    />
                </div>
            ) : null}
        </div>
    );
}

export default UserField;
